/*
  Liste de produits Swiper (blocks/products-list-advanced.liquid)

  Le composant est enregistré globalement depuis theme.liquid : l'éditeur de
  thème injecte le HTML des blocs (ré)activés sans exécuter leurs <script>
  inline, la définition doit donc déjà être présente sur la page.
*/

(() => {

  if (customElements.get('products-list-advanced-component')) {
    return;
  }

  let swiperLoadingPromise = null;

  const loadSwiper = () => {
    if (window.Swiper) {
      return Promise.resolve();
    }

    if (!swiperLoadingPromise) {
      swiperLoadingPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    return swiperLoadingPromise;
  };

  class ProductsListAdvancedComponent extends HTMLElement {

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (!this.isConnected) {
        return;
      }

      loadSwiper().then(() => this.initSwiper()).catch(() => {});
    }

    initSwiper() {
      const swiperElement = this.querySelector('.swiper');

      if (!swiperElement || !this.isConnected) {
        return;
      }

      /* Re-rendu de l'éditeur : on repart d'une instance propre */
      if (swiperElement.swiper) {
        swiperElement.swiper.destroy(true, true);
      }

      new window.Swiper(swiperElement, {
        cssMode: false,
        autoHeight: false,
        mousewheel: false,
        keyboard: false,
        /* Recalcule les slides quand le carrousel devient visible (ex. onglet caché) */
        observer: true,
        observeParents: true,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        },
        slidesPerView: parseInt(this.dataset.columnsMobile, 10) || 2,
        spaceBetween: parseFloat(this.dataset.gapMobile) || 0,
        breakpoints: {
          750: {
            slidesPerView: parseInt(this.dataset.columnsTablet, 10) || 3,
            spaceBetween: parseFloat(this.dataset.gapDesktop) || 0
          },
          1024: {
            slidesPerView: parseInt(this.dataset.columnsDesktop, 10) || 4,
            spaceBetween: parseFloat(this.dataset.gapDesktop) || 0
          }
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2
        }
      });
    }

  }

  customElements.define('products-list-advanced-component', ProductsListAdvancedComponent);

  if (window.Shopify && window.Shopify.designMode) {
    /* Après un re-rendu de section, le DOM peut être morphé sans déclencher
       connectedCallback : on ré-initialise les carrousels concernés. */
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('products-list-advanced-component').forEach((list) => list.init());
    });
  }

})();
